import axios from 'axios'
import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import swal from 'sweetalert2'
import DashboardLayout from '../../../components/ui/DashboardLayout'
import Loading from '../../../components/ui/Loading'
import { LoaderIcon, ViewIcon } from '../../../components/ui/Swicons'
import { devURL, titleCase } from '../../../utils'
import NoTransaction from './NoTransaction'
export default function TransactionList() {
  const token = localStorage.getItem('swToken')
  const [transactionData, setTransactionData] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const [recipientData, setRecipientData] = useState([])
  const [recipientId, setRecipientId] = useState()
  const [disablePage, setDisablePage] = useState(false)
  const [rec_name, setRec_name] = useState('')
  const [page, setPage] = useState(searchParams.get('page') || 1)
  const [paginatePages, setPaginatePages] = useState([])
  const [loader, isLoading] = useState(true)
  const [datalistId, setDatalistId] = useState('list')

  const navigate = useNavigate()

  useEffect(() => {
    getTransactionData()
    if (searchParams.get('page') != page) {
      setSearchParams({ page: page })
    }
  }, [page])

  useEffect(() => {
    if (searchParams.get('page')) {
      setPage(searchParams.get('page'))
    } else {
      setPage(1)
    }
  }, [searchParams])

  useEffect(() => {
    getRecipientsData()
  }, [])

  const getTransactionData = () => {
    isLoading(true)
    axios
      .get(`${devURL}/transfer/get?page=` + page, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data.status) {
          setTransactionData(res.data.transfers)
          let pageArray = []
          for (let i = 1; i <= res.data.pages; i++) {
            pageArray.push(i)
          }
          setPaginatePages(pageArray)
          isLoading(false)
        }
      })
      .catch((err) => {
        isLoading(false)
        if (err.response.status === 401) {
          toast.error('Session expired please login again')
          localStorage.removeItem('swToken')
          return navigate('/Login')
        }
        console.log(err)
      })
  }

  const getSearchRecipient = () => {
    axios
      .get(`${devURL}/transfer/get-by-recipient/` + recipientId, {
        headers: { token: token },
      })
      .then((res) => {
        setTransactionData(res.data)
        setDisablePage(true)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getTransactionDetails = (Transaction_id) => {
    if (Transaction_id !== '') {
      isLoading(true)
      async function callApi() {
        await axios
          .post(
            `${devURL}/transfer/deposit`,
            { transfer_id: Transaction_id },
            { headers: { token: token } }
          )
          .then((res) => {
            if (res.data.status) {
              isLoading(false)
              swal.fire({
                title: 'Transaction Details',
                html:
                  '<div class="text-left text-slate-600">' +
                  '<b>Title :</b> ' +
                  res.data.title +
                  '<br />' +
                  '<b>Send Amount :</b> ' +
                  res.data.sent_amount +
                  ' ' +
                  res.data.src_currency +
                  ' <br />' +
                  '<b>Provider Name :</b> ' +
                  res.data.entity_name +
                  ' <br />' +
                  '<b>IBAN :</b> ' +
                  res.data.IBAN +
                  ' <br />' +
                  '<b>Use Deposite Code :</b> ' +
                  res.data.deposit_code +
                  ' <br />' +
                  '<b>Transfer Date :</b> ' +
                  format(
                    new Date(res.data.date_of_transfer),
                    'yyyy-MM-dd - HH:mm'
                  ) +
                  '<br />' +
                  '</div>',
                dangerMode: true,
                showCloseButton: true,
              })
            }
          })
          .catch((err) => {
            isLoading(false)
            console.log(err)
          })
      }
      callApi()
    }
  }

  const getRecipientsData = () => {
    axios
      .get(`${devURL}/recipient/all`, {
        headers: { token: token },
      })
      .then((res) => {
        setRecipientData(res.data)
        let reSultDisc = {}
        res.data.map(
          (recipient, index) =>
            (reSultDisc[recipient._id] =
              recipient.recipient_name +
              ' (' +
              recipient.recipient_nick_name +
              ')')
        )
        let names = {}
        res.data.map(
          (recipient, index) =>
            (names[recipient.recipient_name] = recipient._id)
        )
        setRec_name(names)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error('Session expired please login again')
          localStorage.removeItem('swToken')
          navigate('/Login')
        }
        console.log(err)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  const handleSearchChange = (e) => {
    setRecipientId(rec_name[e.target.value])
    setDatalistId('list')
  }

  const handleFocus = () => {
    setDatalistId('')
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loading />
      ) : transactionData.length === 0 ? (
        <div className='flex items-center justify-center pt-8'>
          <NoTransaction />
        </div>
      ) : (
        <div className='flex justify-center mx-auto lg:block'>
          <div className='flex-grow min-h-full'>
            <div className='block lg:flex justify-around'>
              <div className='text-xl font-bold mt-2 lg:-ml-0'>
                <p className='page-title'>Transfer History</p>
              </div>
              <div className='lg:float-right'>
                <form onSubmit={handleSubmit}>
                  <div class='flex justify-center'>
                    <div class='mb-3 w-full mt-6 lg:mt-0 xl:w-96'>
                      <div class='relative flex justify-center items-stretch w-full mb-4'>
                        <input
                          type='search'
                          class='form-control relative w-3/5 lg:w-4/5 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
                          placeholder='Enter recipient name'
                          onChange={handleSearchChange}
                          onFocus={handleFocus}
                          list='list'
                        />
                        <button
                          class='btn px-6 py-2.5 bg-themeColor text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-themeHover hover:shadow-lg focus:bg-blue-700  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out flex items-center'
                          type='button'
                          id='button-addon2'
                          onClick={() => getSearchRecipient()}
                        >
                          <svg
                            aria-hidden='true'
                            focusable='false'
                            data-prefix='fas'
                            data-icon='search'
                            class='w-4'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 512 512'
                          >
                            <path
                              fill='currentColor'
                              d='M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z'
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <datalist id={datalistId}>
                    {recipientData.length > 0 && (
                      <>
                        {recipientData.map((recipient, index) => {
                          if (!recipient.is_deleted) {
                            return (
                              <option
                                className='py-2'
                                value={recipient.recipient_name}
                                key={recipient._id}
                              >
                                ({recipient.recipient_nick_name})
                              </option>
                            )
                          }
                        })}
                      </>
                    )}
                  </datalist>
                </form>
              </div>
            </div>

            <div className='flex justify-center lg:block'>
              <div className='transaction-table mt-8 ml-2 lg:mr-6 lg:ml-0'>
                <table className='table-auto w-4/5 lg:w-3/4 relative mx-auto'>
                  <thead className='border-b'>
                    <tr>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Recipient
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        You
                        <br />
                        transferred (EURO)
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Recipient
                        <br />
                        received (INR)
                      </th>
                      <th className='text-center text-gray-400 py-5 text-xs lg:text-sm'>
                        Date
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Rate
                      </th>
                      <th className='text-center text-gray-400 py-5 text-xs lg:text-sm w-30 '>
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData.length > 0 && (
                      <>
                        {transactionData.map((transaction, index) => (
                          <tr
                            key={'transaction-table-' + index}
                            className='relative hover:bg-blue-100'
                            onClick={() =>
                              navigate(
                                `/transaction-details/${transaction._id}`
                              )
                            }
                          >
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800 px-2 rounded-l-lg'>
                              {titleCase(transaction.recipient_name)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800'>
                              {transaction.sent_amount.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800'>
                              {transaction.received_amount.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-center text-gray-800'>
                              {format(
                                new Date(transaction.date_of_transfer),
                                'yyyy-MM-dd - HH:mm'
                              )}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800'>
                              {transaction.rate.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-center text-gray-800 px-2 rounded-r-lg'>
                              <p
                                className={
                                  transaction.is_completed
                                    ? 'sw-completed'
                                    : transaction.money_received &&
                                      transaction.is_vda_credited
                                    ? 'sw-verified'
                                    : transaction.user_deposit_confirmed
                                    ? 'sw-deposited'
                                    : 'sw-initiated'
                                }
                              >
                                {transaction.is_deleted
                                  ? 'Cancelled'
                                  : transaction.is_completed
                                  ? 'Completed'
                                  : transaction.money_received &&
                                    transaction.is_vda_credited
                                  ? 'Verified'
                                  : transaction.user_deposit_confirmed
                                  ? 'Waiting'
                                  : 'Initiated'}
                              </p>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    {loader && <LoaderIcon />}
                    {!loader && transactionData.length === 0 && (
                      <tr>
                        <td
                          colSpan='9'
                          className='py-6 text-xs lg:text-sm text-center sw-cancelled'
                        >
                          No recipients record were found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {disablePage ? (
                  <></>
                ) : (
                  <div className='sw-pagination text-center mt-6'>
                    <ul>
                      {paginatePages.map((value, index) => (
                        <li
                          key={'sp-' + index}
                          className={page === value ? 'sw-active' : ''}
                          onClick={() => setPage(value)}
                        >
                          {value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  )
}
